import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card, Modal } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';

const RetailerApprovalForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  
  const [formData] = useState({
    parentId: 'BXD004081',
    uniqueId: id || 'BXD004124',
    mobile: '9922234743',
    nameAsPan: 'VIJAY LALCHAND PINJANI',
    panNumber: 'AJJPP1891Q',
    fatherName: 'NA',
    dob: '30-05-1976',
    email: 'saharaenterprises123@gmail.com',
    pincode: '421004',
    shopName: 'Sahara enterprises',
    shopPincode: '421004',
    aadharAddress: 'Pukhmani Co-Op Hsg Society, Flat No. 3/4, Plot No. 421, Ulhasnagar, Ulhasnagar-4, Ulhasnagar',
    status: 'SUBMITTED',
    date: '2023-11-18',
    time: '03:18 PM',
    userType: 'distributor',
    building: 'shop no 3 rukmani cop hsg soc ot ulhasnagar 4',
    landmark: 'puj panchayat hall',
    city: 'Ulhasnagar 4',
    lat: '19.217963333333334',
    long: '73.160515',
    onboardingStep: 'SELFIE & BUSINESS PROOF'
  });

  const [approvalAction, setApprovalAction] = useState('Approve');
  const [remark, setRemark] = useState('');
  const [showImageModal, setShowImageModal] = useState(false);
  const [modalImageTitle, setModalImageTitle] = useState('');

  const handleImageView = (title) => {
    setModalImageTitle(title);
    setShowImageModal(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle approval/rejection logic here
    alert(`${approvalAction} action submitted with remark: ${remark}`);
    navigate('/user-management/retailer-approval');
  };

  return (
    <Container fluid className="">
      <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
        <Card className="shadow-sm">
          <Card.Body>
          <h4 className="mb-3" style={{ fontSize: '1.25rem' }}>Retailer Approval</h4>
          
          <Form onSubmit={handleSubmit}>
            <table className="table table-bordered" style={{ fontSize: '0.875rem' }}>
              <tbody>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <td style={{ width: '30%', fontWeight: '600' }}>Parent id</td>
                  <td>{formData.parentId}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: '600' }}>Unique id</td>
                  <td>{formData.uniqueId}</td>
                </tr>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <td style={{ fontWeight: '600' }}>Mobile</td>
                  <td>{formData.mobile}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: '600' }}>Name as per Pan</td>
                  <td>{formData.nameAsPan}</td>
                </tr>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <td style={{ fontWeight: '600' }}>Pan number</td>
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <Button 
                        size="sm" 
                        style={{ 
                          backgroundColor: '#17a2b8', 
                          border: 'none',
                          padding: '3px 8px',
                          fontSize: '0.8rem'
                        }}
                        onClick={() => handleImageView('Aadhaar Back')}
                      >
                        <i className="bi bi-image me-1" style={{ fontSize: '0.8rem' }}></i>Aadhaar Back
                      </Button>
                      <Button 
                        size="sm" 
                        style={{ 
                          backgroundColor: '#6c757d', 
                          border: 'none',
                          padding: '3px 8px',
                          fontSize: '0.8rem'
                        }}
                        onClick={() => handleImageView('Aadhaar Front')}
                      >
                        <i className="bi bi-image me-1" style={{ fontSize: '0.8rem' }}></i>Aadhaar Front
                      </Button>
                      <Button 
                        size="sm" 
                        style={{ 
                          backgroundColor: '#007bff', 
                          border: 'none',
                          padding: '3px 8px',
                          fontSize: '0.8rem'
                        }}
                        onClick={() => handleImageView('Pan Image')}
                      >
                        <i className="bi bi-image me-1" style={{ fontSize: '0.8rem' }}></i>Pan Image
                      </Button>
                      <span className="ms-3">{formData.panNumber}</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: '600' }}>Father name</td>
                  <td>
                    <Form.Control
                      type="text"
                      defaultValue={formData.fatherName}
                      style={{ maxWidth: '100%' }}
                    />
                  </td>
                </tr>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <td style={{ fontWeight: '600' }}>Dob</td>
                  <td>
                    <Form.Control
                      type="text"
                      defaultValue={formData.dob}
                      style={{ maxWidth: '100%' }}
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: '600' }}>Email</td>
                  <td>{formData.email}</td>
                </tr>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <td style={{ fontWeight: '600' }}>Pincode</td>
                  <td>{formData.pincode}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: '600' }}>Shop name</td>
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <Button 
                        size="sm" 
                        style={{ 
                          backgroundColor: '#17a2b8', 
                          border: 'none',
                          padding: '3px 8px',
                          fontSize: '0.8rem'
                        }}
                        onClick={() => handleImageView('Business Proof')}
                      >
                        <i className="bi bi-image me-1" style={{ fontSize: '0.8rem' }}></i>Business Proof
                      </Button>
                      <Button 
                        size="sm" 
                        style={{ 
                          backgroundColor: '#17a2b8', 
                          border: 'none',
                          padding: '3px 8px',
                          fontSize: '0.8rem'
                        }}
                        onClick={() => handleImageView('Selfie Image')}
                      >
                        <i className="bi bi-image me-1" style={{ fontSize: '0.8rem' }}></i>Selfie Image
                      </Button>
                      <Form.Control
                        type="text"
                        defaultValue={formData.shopName}
                        className="ms-3"
                        style={{ flex: 1 }}
                      />
                    </div>
                  </td>
                </tr>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <td style={{ fontWeight: '600' }}>Shop pincode</td>
                  <td>
                    <Form.Control
                      type="text"
                      defaultValue={formData.shopPincode}
                      style={{ maxWidth: '100%' }}
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: '600' }}>Aadhar Address</td>
                  <td>
                    <Form.Control
                      type="text"
                      defaultValue={formData.aadharAddress}
                      style={{ maxWidth: '100%' }}
                    />
                  </td>
                </tr>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <td style={{ fontWeight: '600' }}>Status</td>
                  <td>{formData.status}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: '600' }}>Date</td>
                  <td>{formData.date}</td>
                </tr>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <td style={{ fontWeight: '600' }}>Time</td>
                  <td>{formData.time}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: '600' }}>User type</td>
                  <td>
                    <Form.Control
                      type="text"
                      defaultValue={formData.userType}
                      style={{ maxWidth: '100%' }}
                    />
                  </td>
                </tr>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <td style={{ fontWeight: '600' }}>Building</td>
                  <td>
                    <Form.Control
                      type="text"
                      defaultValue={formData.building}
                      style={{ maxWidth: '100%' }}
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: '600' }}>Landmark</td>
                  <td>
                    <Form.Control
                      type="text"
                      defaultValue={formData.landmark}
                      style={{ maxWidth: '100%' }}
                    />
                  </td>
                </tr>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <td style={{ fontWeight: '600' }}>City</td>
                  <td>
                    <Form.Control
                      type="text"
                      defaultValue={formData.city}
                      style={{ maxWidth: '100%' }}
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: '600' }}>Lat</td>
                  <td>{formData.lat}</td>
                </tr>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <td style={{ fontWeight: '600' }}>Long</td>
                  <td>{formData.long}</td>
                </tr>
                <tr>
                  <td style={{ fontWeight: '600' }}>Onboarding Step (Last Screen)</td>
                  <td>
                    <Form.Select style={{ maxWidth: '100%' }} defaultValue={formData.onboardingStep}>
                      <option>SELFIE & BUSINESS PROOF</option>
                      <option>PAN & AADHAAR</option>
                      <option>PERSONAL DETAILS</option>
                      <option>SHOP DETAILS</option>
                    </Form.Select>
                  </td>
                </tr>
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                  <td style={{ fontWeight: '600' }}>Action</td>
                  <td>
                    <Form.Select 
                      value={approvalAction}
                      onChange={(e) => setApprovalAction(e.target.value)}
                      style={{ maxWidth: '300px' }}
                    >
                      <option value="Approve">Approve</option>
                      <option value="Re-Upload">Re-Upload</option>
                    </Form.Select>
                  </td>
                </tr>
                <tr>
                  <td style={{ fontWeight: '600' }}>Remark</td>
                  <td>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Enter any remark"
                      value={remark}
                      onChange={(e) => setRemark(e.target.value)}
                      style={{ maxWidth: '100%' }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="text-center mt-4">
              <Button 
                type="submit" 
                style={{
                  width: '100%',
                  maxWidth: '100%',
                  padding: '6px 12px',
                  fontSize: '16px',
                  backgroundColor: 'transparent',
                  border: '1px solid #007bff',
                  color: '#007bff',
                  fontWeight: '500'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#007bff';
                  e.currentTarget.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#007bff';
                }}
              >
                Submit
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
      </div>

      {/* Image View Modal */}
      <Modal show={showImageModal} onHide={() => setShowImageModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{modalImageTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <div style={{ minHeight: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
            <div>
              <i className="bi bi-image" style={{ fontSize: '80px', color: '#6c757d' }}></i>
              <p className="mt-3 text-muted">Document Image Preview</p>
              <p className="text-muted small">({modalImageTitle})</p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowImageModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default RetailerApprovalForm;

